import { Carousel } from "antd";
import { useRef, useState } from "react";
import styles from "./index.module.less";
export default function Slick(props) {
  const { cooperate, num } = props;
  const [settings, setSettings] = useState({
    dots: false,
    className: styles.slider,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: num % 2 === 0 ? 1 : -1,
    autoplay: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    speed: 8000,
    autoplaySpeed: 0,
    cssEase: "linear",
    variableWidth: true,
  });

  const carouselRef = useRef(null);

  return (
    <div className={styles.container}>
      <Carousel {...settings} ref={carouselRef}>
        {cooperate.list.map((item, index) => {
          return (
            <div key={index} style={{ width: 240 }}>
              <img src={item?.img?.[0]?.url} alt="" width={240} />
            </div>
          );
        })}
      </Carousel>
    </div>
  );
}
